(function () {
  const destroyAnnSlider = (section) => {
    if (!section || !section.classList.contains('section-announcement')) return;

    const slider = section.querySelector('.announcement-bar--swiper');
    if (!slider) return;

    if (slider.swiper && typeof slider.swiper.destroy === 'function') {
      slider.swiper.destroy(true, true);
    }

    slider.classList.remove('announcement-bar--static');
  };

  const initAnnSlider = (section) => {
    if (!section || !section.classList.contains('section-announcement')) return;

    const slider = section.querySelector('.announcement-bar--swiper');

    if (!slider) return;

    destroyAnnSlider(section);

    const slideCount = slider.querySelectorAll('.swiper-slide').length;
    const rowsMobile = Number(slider.dataset.rowsMobile) || 1;
    const rowsDesktop = Number(slider.dataset.rows) || 1;
    const needsMobileSlider = slideCount > rowsMobile;
    const needsDesktopSlider = slideCount > rowsDesktop;

    // A single visible message should behave like a static announcement.
    // Initializing Swiper here creates an empty drag state and can expose a
    // blank frame while the customer is trying to scroll the page.
    if (!needsMobileSlider && !needsDesktopSlider) {
      slider.classList.add('announcement-bar--static');
      return;
    }

    if (typeof Swiper !== 'function') return;

    const swiperParams = {
      speed: Number(slider.dataset.speed) || 800,
      direction: 'vertical',
      spaceBetween: 0,
      slidesPerView: rowsMobile,
      autoHeight: true,
      loop: slideCount > Math.max(rowsMobile, rowsDesktop),
      rewind: true,
      watchOverflow: true,
      allowTouchMove: needsMobileSlider,
      autoplay:
        needsMobileSlider
          ? {
              enabled: true,
              delay: Number(slider.dataset.delay) || 2000,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }
          : { enabled: false },
      breakpoints: {
        765: {
          slidesPerView: rowsDesktop,
          allowTouchMove: needsDesktopSlider,
          autoplay:
            needsDesktopSlider
              ? {
                  enabled: true,
                  delay: Number(slider.dataset.delay) || 2000,
                  pauseOnMouseEnter: true,
                  disableOnInteraction: false,
                }
              : { enabled: false },
        },
      },
    };

    new Swiper(slider, swiperParams);
  };

  initAnnSlider(document.currentScript.parentElement);

  document.addEventListener('shopify:section:load', function (event) {
    initAnnSlider(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAnnSlider(event.target);
  });
})();

